import HttpService from "@/hooks/Https-services";
import useConfig from "@/hooks/useConfig";
import PageRoutes, {
  APIRoutes,
  INSIDER_PLAN_ID,
  UserRoles,
} from "@/utils/constants";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  darken,
  Grid,
  lighten,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import FaviroiteTeam from "./FaviroiteTeam";
import HighLightsAndShortContent from "./HighLightsAndShortContent";
import UpcomingSchedule from "./UpcomingSchedule";
import StandingTable from "./StandingTable";
import { useTeamContext } from "@/Common/Contex/TeamContext";
import TeamNameRow from "./TeamNameRow";
import { getCurrentAuth } from "@/hooks/http-server";
import useCommonDetails from "@/Common/Hooks/useCommonDetails";
import { useNavigate } from "react-router-dom";
import LatestCondensedGames from "./LatestCondensedGames";
import XFeed from "./XFeed";
import LeagueNews from "./LeagueNews";
import { isCurrentTimeMoreThanTenMinutesBefore } from "../HomePage";
const GroupHeader = styled("div")(({ theme }: any) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === "light"
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled("ul")({
  padding: 0,
});

const Team = () => {
  const configData = useConfig();
  const [channelOption, setChannelOption] = useState<any>([]);
  const [teamOption, setTeamOption] = useState<any>([]);
  const [liveGame, setLiveGame] = useState<any>(null);
  const [localFilterValue, setLocalFilterValue] = useState<any>({
    channel: "",
    team_id: "",
  });
  const navigate = useNavigate();
  const [subscriptionDetails, setSubscriptionDetails] = useState<any>({});
  const [planDetails, setPlanDetails] = useState<any>(null);
  const auth = getCurrentAuth();
  const userDetails = useCommonDetails();
  const [currentChannelConfig, setCurrentChannelConfig] = useState<{
    news_url: string | null;
    xfeed_handle: string | null;
  } | null>({
    news_url: "nahl",
    xfeed_handle: "NAHLHockey",
  });
  const [isLoading, setIsLoading] = useState(false);
  const {
    setCurrentSelectedTeam,
    currentSelectedTeam,
    latestCondensedGame,
  }: any = useTeamContext();
  const [userFavoriteTeams, setUserFavoriteTeams] = useState<any>([]);
  const options = teamOption?.map((option: any) => {
    return {
      firstLetter: option.customer == 0 ? "My Favorites" : "Teams",
      ...option,
    };
  });
  const OnFilterLocalChange = (event: any, name: string) => {
    let value = event.target.value;

    setLocalFilterValue({
      ...localFilterValue,
      [name]: value,
    });
    if (name === "channel") {
      FetchTeams(value);
    }
  };
  const FetchChannels = async () => {
    try {
      const result = await HttpService.getapi(
        APIRoutes.ChannelOption.replace(":id", configData.customer)
      );

      setChannelOption(result.data.data);
    } catch (error) {}
  };
  const GetSchedule = useCallback(async () => {
    if (!currentSelectedTeam?.team_id) {
      return;
    }
    try {
      setIsLoading(true);
      const params: any = {
        status: "live",
        page: 1,
        limit: 1,
        customer: configData.customer,
        team: currentSelectedTeam?.team_id,
      };
      const games = await HttpService.getapi(
        `${APIRoutes.TeamEventsList}?` + new URLSearchParams(params)
      );
      const isPast = isCurrentTimeMoreThanTenMinutesBefore(
        games?.data?.data[0]?.game_date_time
      );

      if (isPast) {
        setLiveGame(games?.data?.data[0]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [configData.customer, currentSelectedTeam?.team_id]);
  useEffect(() => {
    GetSchedule();
  }, [GetSchedule]);
  const mapChannelToStream = useCallback(() => {
    // TODO: Implement channel mapping logic
    let xfeed_handle = "NAHLHockey";
    let news_url = "nahl";

    switch (localFilterValue.channel) {
      case "9":
        xfeed_handle = "NAHLHockey";
        news_url = "nahl";
        break;
      case "10":
        xfeed_handle = "NA3HL";
        news_url = "na3hl";
        break;
      default:
        xfeed_handle = "NAHLHockey";
        news_url = "nahl";
        break;
    }

    // Update the channel config without creating a dependency on the current state
    setCurrentChannelConfig((prevConfig) => {
      if (prevConfig) {
        return {
          ...prevConfig,
          xfeed_handle,
          news_url,
        };
      }
      return {
        xfeed_handle,
        news_url,
      };
    });
  }, [localFilterValue.channel]); // Remove currentChannelConfig dependency

  const FetchTeams = async (channel_id: any) => {
    try {
      const team: {
        label: any;
        team_id: any;
        customer?: any;
        team_description: any;
        team_short_name: any;
        team_logo_url: any;
      }[] = [];

      if (channel_id != 0 || !channel_id) {
        const result = await HttpService.getapi(
          APIRoutes.Team.replace(":id", channel_id || "").replace(
            ":customer",
            configData.customer
          )
        );
        result.data.data?.forEach((element: any) => {
          const temp = {
            label: `${element?.team_name} ${element?.team_mascot}`,
            ...element,
          };
          if (element?.team_description) {
            temp.label = temp?.label + " (" + element?.team_description + ")";
          }
          team.push(temp);
        });
      }
      setTeamOption(team);
    } catch (error) {
    } finally {
    }
  };
  const FetchFaviroiteTeam = useCallback(async () => {
    if (teamOption?.length == 0) {
      return;
    }
    try {
      const res = await HttpService.get(APIRoutes.GetUsersFavoriteTeam);
      if (res?.data?.data) {
        const favoriteTeams: {
          label: string;
          customer: number;
          team_id: string | number;
          team_description: string;
          team_short_name: string;
          team_logo_url: string;
        }[] = [];
        res.data.data?.UserFavouriteTeam?.forEach((element: any) => {
          const temp = {
            label: `${element?.team_name} ${element?.team_mascot}`,
            customer: 0,
            team_id: element?.team_id,
            team_description: element?.team_description,
            team_short_name: element?.team_short_name,
            team_logo_url: element?.team_logo_url,
          };

          if (element?.team_description) {
            temp.label = temp?.label + " (" + element?.team_description + ")";
          }
          favoriteTeams.push(temp);
        });

        setUserFavoriteTeams(favoriteTeams);
        if (
          !currentSelectedTeam &&
          favoriteTeams.length > 0 &&
          teamOption.length > 0
        ) {
          // Make sure the selected team has the same structure as options
          const firstTeam = favoriteTeams[0];
          const findTeam = teamOption?.find(
            (t: any) => t.team_id == firstTeam?.team_id
          );

          if (firstTeam) {
            setCurrentSelectedTeam({
              ...firstTeam,
              ...findTeam,
              firstLetter: "My Favorites",
            });
          }
        }
      }
    } catch (error) {
    } finally {
    }
  }, [teamOption]);

  useEffect(() => {
    FetchChannels();
    FetchTeams(0);
  }, []);
  useEffect(() => {
    FetchFaviroiteTeam();
  }, [FetchFaviroiteTeam]);
  const GetUserSubscriptionData = useCallback(async () => {
    if (!auth.AccessToken) {
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      const res = await HttpService.get(APIRoutes.GetSubscriptionDetials);

      if (res?.data?.data) {
        setSubscriptionDetails(res?.data?.data?.subscription);
        setPlanDetails(res?.data?.data);
        setIsLoading(false);
        return res?.data?.data;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    if (auth.AccessToken) {
      GetUserSubscriptionData();
    }
  }, [GetUserSubscriptionData, auth.AccessToken]);
  useEffect(() => {
    mapChannelToStream();
  }, [mapChannelToStream]);
  const hasPermition = () => {
    if (
      (planDetails?.plan_type_id == INSIDER_PLAN_ID &&
        !subscriptionDetails?.pause_collection) ||
      [
        UserRoles.HTP_ADMIN,
        UserRoles.LEAGUE_ADMIN,
        UserRoles.FREE_WATCH_D,
      ].includes(userDetails?.UserRoleID)
    ) {
      return true;
    } else {
      return false;
    }
  };
  console.log(hasPermition());

  // Show the main content if user has permission, otherwise show the content with overlay
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          pt: 4,
        }}
      >
        <Box sx={{ px: 2 }}>
          <Grid container item xs={12}>
            {userFavoriteTeams?.length > 0 ? (
              <Grid item xs={12} md={5}>
                <FaviroiteTeam
                  teams={teamOption}
                  userFavoriteTeams={userFavoriteTeams}
                />
              </Grid>
            ) : (
              <Grid item xs={12} md={5}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    onClick={() => navigate(PageRoutes.AccountSettings)}
                    variant="contained"
                  >
                    Set up your favorite team
                  </Button>
                </Box>
              </Grid>
            )}

            <Grid container item xs={12} md={7} spacing={2} sx={{ pb: 1 }}>
              <Grid item xs={12} md={6}>
                <label className="select-wrapper">
                  <span> Channel </span>
                  <select
                    className="custom-select"
                    value={localFilterValue.channel}
                    onChange={(event: any) =>
                      OnFilterLocalChange(event, "channel")
                    }
                    defaultValue={localFilterValue.channel}
                  >
                    <option value="">Select All</option>
                    {channelOption
                      ?.sort((a: any, b: any) =>
                        a?.channel_weight < b?.channel_weight ? -1 : 1
                      )
                      ?.map((option: any) => (
                        <option value={option.channel_id}>
                          {option?.channel_name}
                        </option>
                      ))}
                  </select>
                </label>
              </Grid>

              <Grid item sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  getOptionLabel={(option) => option.label || ""}
                  options={options}
                  groupBy={(option) => option.firstLetter}
                  isOptionEqualToValue={(option, value) =>
                    option.team_id === value.team_id
                  }
                  onChange={(event: any, value: any) => {
                    OnFilterLocalChange(
                      { target: { value: value?.team_id } },
                      "team"
                    );
                    // Make sure value has all required properties before setting it
                    if (value) {
                      setCurrentSelectedTeam(value);
                      console.log("Selected team:", value);
                    }
                  }}
                  renderGroup={(params) => (
                    <li key={params.key}>
                      <GroupHeader>{params.group}</GroupHeader>
                      <GroupItems>{params.children}</GroupItems>
                    </li>
                  )}
                  value={currentSelectedTeam}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option?.team_id}>
                      <Typography
                        variant="body1"
                        sx={{ fontStyle: "normal", textTransform: "none" }}
                      >
                        {" "}
                        {option?.label}
                      </Typography>
                    </Box>
                  )}
                  size="small"
                  sx={{
                    width: 1,
                    background: "white",
                    fieldset: {
                      borderColor: "#959799",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Team"
                      sx={{
                        borderColor: "#959799",
                        input: { height: "25px" },
                      }}
                    />
                  )}
                  className=""
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>

        {currentSelectedTeam && (
          <Grid item xs={12}>
            <TeamNameRow
              liveGame={liveGame}
              subscriptionDetails={subscriptionDetails}
            />
          </Grid>
        )}
        <Box sx={{ pr: 1, pl: 4 }}>
          {!!currentSelectedTeam && (
            <Grid container item xs={12} spacing={2} sx={{ mb: 2, pr: 2 }}>
              {!!latestCondensedGame && (
                <Grid item xs={12}>
                  <Box sx={{ position: "relative", mt: 1 }}>
                    <Box
                      sx={{
                        opacity: !hasPermition() ? 0.3 : 1,
                        backgroundColor: !hasPermition()
                          ? configData.primary
                          : "",
                        filter: !hasPermition() ? "blur(1px)" : "",
                      }}
                    >
                      <LatestCondensedGames />
                    </Box>
                    {!hasPermition() && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          right: 0,
                          width: 1,
                          bottom: "50%",
                          left: 0,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              textAlign: "center",
                              color: configData.primary,
                              fontSize: 18,
                              fontWeight: 600,
                              display: "flex",
                              alignSelf: "center",
                              flexDirection: "column",
                              justifyContent: "center",
                            }}
                            variant="body1"
                          >
                            This feature is only available to insiders
                          </Typography>
                          <Box>
                            <Box
                              component="button"
                              sx={{
                                backgroundColor: configData.primary,
                                color: "white",
                                border: "none",
                                borderRadius: 1,
                                py: 1,
                                px: 2,
                                fontSize: 16,
                                fontWeight: 600,
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                textTransform: "uppercase !important",
                                "&:hover": {
                                  backgroundColor: darken(
                                    configData.primary,
                                    0.1
                                  ),
                                },
                              }}
                              onClick={() => navigate(PageRoutes.Packages)}
                            >
                              Upgrade Your Plan
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Grid>
              )}

              <Grid item xs={12}>
                <Box sx={{ position: "relative", mt: 1 }}>
                  <Box
                    sx={{
                      opacity: !hasPermition() ? 0.3 : 1,
                      backgroundColor: !hasPermition()
                        ? configData.primary
                        : "",
                      filter: !hasPermition() ? "blur(1px)" : "",
                    }}
                  >
                    <HighLightsAndShortContent />
                  </Box>
                  {!hasPermition() && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: 0,
                        width: 1,
                        bottom: "50%",
                        left: 0,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            textAlign: "center",
                            color: configData.primary,
                            fontSize: 18,
                            fontWeight: 600,
                            display: "flex",
                            alignSelf: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                          variant="body1"
                        >
                          This feature is only available to insiders
                        </Typography>
                        <Box>
                          <Box
                            component="button"
                            sx={{
                              backgroundColor: configData.primary,
                              color: "white",
                              border: "none",
                              borderRadius: 1,
                              py: 1,
                              px: 2,
                              fontSize: 16,
                              fontWeight: 600,
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              textTransform: "uppercase !important",
                              "&:hover": {
                                backgroundColor: darken(
                                  configData.primary,
                                  0.1
                                ),
                              },
                            }}
                            onClick={() => navigate(PageRoutes.Packages)}
                          >
                            Upgrade Your Plan
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Grid>

              {["dev", "nahl"].includes(configData.name) && (
                <Grid container item xs={12} spacing={2}>
                  <Grid item xs={12} md={4} lg={3}>
                    <StandingTable />
                  </Grid>
                  <Grid item xs={12} md={4} lg={6}>
                    <LeagueNews
                      channel={currentChannelConfig?.news_url || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <XFeed
                      teamId={
                        currentChannelConfig?.xfeed_handle || "NAHLHockey"
                      }
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
        </Box>
      </Box>
      <Box>
        {/* {!hasPermition() && (
          <Box
            sx={{
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              position: "fixed",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
            }}
          >
            <Box
              sx={{
                borderRadius: 2,
                p: 4,

                textAlign: "center",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  mb: 2,
                  fontWeight: 600,
                  textTransform: "uppercase !important",
                }}
              >
                Subscriber Content
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, fontStyle: "normal" }}>
                This content is only available to subscribers. Subscribe to
                access team highlights and more premium features.
              </Typography>
              <Box
                component="button"
                sx={{
                  backgroundColor: configData.primary,
                  color: "white",
                  border: "none",
                  borderRadius: 1,
                  py: 1.5,
                  px: 4,
                  fontSize: 16,
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  textTransform: "uppercase !important",
                  "&:hover": {
                    backgroundColor: darken(configData.primary, 0.1),
                  },
                }}
                onClick={() => navigate(PageRoutes.Packages)}
              >
                Upgrade Your Plan
              </Box>
            </Box>
          </Box>
        )} */}
      </Box>
    </Box>
  );
};

export default Team;
